/**
 * Render CODE128 / EAN13 / CODE39 barcodes on mat label SVG placeholders.
 * Requires jsbarcode.all.min.js (JsBarcode global).
 */
(function () {
  'use strict';

  function normalizeFormat(format) {
    var f = (format || 'CODE128').toUpperCase();
    if (f === 'EAN-13' || f === 'EAN13') return 'EAN13';
    if (f === 'CODE39') return 'CODE39';
    return 'CODE128';
  }

  function renderBarcodes(root, options) {
    if (typeof JsBarcode === 'undefined') return;
    root = root || document;
    options = options || {};
    var height = options.height || 32;
    var format = normalizeFormat(options.format);

    root.querySelectorAll('svg.mat-label__barcode').forEach(function (svg) {
      var value = svg.getAttribute('data-barcode-value');
      if (!value) {
        var parent = svg.closest('.mat-label__cell-inner');
        if (parent) value = parent.getAttribute('data-barcode-value');
      }
      if (!value) return;

      var cellFormat = svg.getAttribute('data-barcode-format') || format;
      try {
        JsBarcode(svg, value, {
          format: normalizeFormat(cellFormat),
          width: 1.2,
          height: height,
          displayValue: false,
          margin: 0,
        });
      } catch (e) {
        console.warn('[mat-label-barcodes]', value, e);
      }
    });
  }

  window.MatLabelBarcodes = {
    render: renderBarcodes,
  };
})();
